// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { KitTag } from './kit-tag';
import { Program } from './program';
import { ProgramKitIssuanceUserGroupMap } from './program-kit-issuance-user-group-map';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ProgramKitIssuance extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Guid key */
  id!: string;
  /** Guid FK kitTag */
  kitTagId!: string;
  /** Int32 */
  maximumQty?: number;
  /** Int32 */
  minimumQty?: number;
  /** String(60) */
  name!: string;
  /** Guid FK program */
  programId!: string;
  /** Binary */
  rowVersion!: any;
  /** FK kitTagId */
  kitTag!: KitTag;
  /** FK programId */
  program!: Program;
  /** Inv FK programKitIssuanceId */
  programKitIssuanceUserGroupMaps!: ProgramKitIssuanceUserGroupMap[];
}

